import React from 'react';

export const renderStringOrComponent = (input, TextWrapper, props = {}) =>
  typeof input !== 'string' ? input : <TextWrapper {...props}>{input}</TextWrapper>;
